module.exports = __webpack_public_path__ + "img/1.1760d349.png";